// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__AOOj7","iframeContainer":"styles_iframeContainer__zVffd"};